// extracted by mini-css-extract-plugin
module.exports = {"catalogRow":"CatalogEdit_catalogRow__3WlnB","typeInput":"CatalogEdit_typeInput__2XEJB","numberInput":"CatalogEdit_numberInput__32raz","ButtonBar":"CatalogEdit_ButtonBar__1s-Xa"};